module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-login-extra"
  }, [_c('van-cell-group', {
    staticClass: "score-cell"
  }, [_c('van-field', {
    attrs: {
      "name": "身份证号",
      "left-icon": require('../../../assets/images/score/login-card.png'),
      "clearable": "",
      "readonly": _vm.readonly,
      "placeholder": "请输入身份证号",
      "rules": [{
        required: true,
        message: '身份证号'
      }]
    },
    on: {
      "focus": _vm.onFocus
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "score-button"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #72CAF9, #2492FB)"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n            登录\n          ")]) : _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #65F6D6, #0EB993)"
    }
  }, [_vm._v("\n            登录中...\n          ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id_code == 'X001'),
      expression: "formData.id_code == 'X001'"
    }],
    staticClass: "fr flex-start"
  }, [_c('div', {
    staticClass: "mr10"
  }, [_vm._v("云上版")]), _vm._v(" "), _c('van-switch', {
    attrs: {
      "inactive-color": "#eee",
      "size": "24px"
    },
    on: {
      "change": _vm.switchChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml10"
  }, [_vm._v("内网版")])], 1)], 1)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "正在进行"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-cell-group', _vm._l((_vm.list), function(item, index) {
    return _c('van-cell', {
      attrs: {
        "title": item.saiqu_name + ' ' + item.title,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.toScoreCheck(item.id)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.keyShow,
      "extra-key": "X",
      "close-button-text": "完成"
    },
    on: {
      "close": function($event) {
        _vm.keyShow = false
      }
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-login-box"
  }, [_c('div', {
    staticClass: "score-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e979d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameScoreSaiLogin.vue
// module id = 2278
// module chunks = 0